// @ts-nocheck
/**
 * カードコレクションシステム - 経済定数
 *
 * ゲーム内経済に関する全ての定数を定義
 */

// ========================================
// 経済定数
// ========================================

export const ECONOMY = {
  // 初期値
  INITIAL_GOLD: 10000,

  // 対戦報酬
  BATTLE_REWARD_GOLD: 5000,      // 対戦完了時（勝敗問わず）
  BATTLE_WIN_BONUS_PACKS: 1,    // 勝利ボーナス（パック数）

  // パック
  PACK_PRICE: 3500,             // 1パックの価格
  CARDS_PER_PACK: 5,            // 1パックの枚数
};

// ========================================
// レアリティ定義
// ========================================

// レアリティ一覧（低い順）
export const RARITIES = ['C', 'UC', 'R', 'SR', 'UR', 'HR', 'SEC', 'ALT', 'SP', 'GR'];

// レアリティ表示名
export const RARITY_NAMES = {
  C: 'コモン',
  UC: 'アンコモン',
  R: 'レア',
  SR: 'スーパーレア',
  UR: 'ウルトラレア',
  HR: 'ホログラム',
  SEC: 'シークレット',
  ALT: 'オルタナティブ',
  SP: 'スペシャル',
  GR: 'ゴッドレア',
};

// レアリティ価値倍率
// 高レアほどパック期待値との乖離を小さく設定
// HR: 5.8倍安い, SEC: 3.5倍, ALT: 3倍, SP: 2.5倍, GR: 2倍
export const RARITY_MULTIPLIERS = {
  C: 1.0,
  UC: 1.3,
  R: 2.0,
  SR: 5.0,
  UR: 15.0,
  HR: 150.0,      // 旧30 → 市場価格約48,000G（10戦）
  SEC: 600.0,     // 旧50 → 市場価格約192,000G（40戦）
  ALT: 1800.0,    // 旧50 → 市場価格約576,000G（117戦）
  SP: 5500.0,     // 旧60 → 市場価格約1,760,000G（352戦）
  GR: 27000.0,    // 旧100 → 市場価格約8,640,000G（1,728戦）
};

// レアリティカラー（UI表示用）
export const RARITY_COLORS = {
  C: '#808080',      // グレー
  UC: '#2ecc71',     // 緑
  R: '#3498db',      // 青
  SR: '#9b59b6',     // 紫
  UR: '#f1c40f',     // 金
  HR: '#e74c3c',     // 赤（ホロ）
  SEC: '#1abc9c',    // ターコイズ
  ALT: '#e91e63',    // ピンク
  SP: '#ff9800',     // オレンジ
  GR: '#ffd700',     // ゴールド（グラデーション用）
};

// ========================================
// ティア定義
// ========================================

export const TIERS = ['S', 'A', 'B', 'C', 'D'];

// ティア判定閾値
export const TIER_THRESHOLDS = {
  S: 700,
  A: 500,
  B: 350,
  C: 200,
  D: 0,
};

// ティア別最低レアリティ
export const TIER_MIN_RARITY = {
  S: 'R',    // Sティアは最低でもR
  A: 'UC',   // Aティアは最低でもUC
  B: 'C',
  C: 'C',
  D: 'C',
};

// ========================================
// パック排出率
// ========================================

// 枠1-2: C確定
// 枠3-4: C/UC（UC 30%）
export const SLOT_3_4_UC_RATE = 0.3;

// 枠5（R以上確定枠）の排出率
export const SLOT_5_RATES = {
  R: 0.75,
  SR: 0.18,
  UR: 0.05,
  HR: 0.012,
  SEC: 0.005,
  ALT: 0.002,
  SP: 0.0008,
  GR: 0.0002,
};

// ========================================
// ストレージ設定
// ========================================

export const STORAGE = {
  KEY: 'magicSpirit_playerData',
  VERSION: 1,
};

// ========================================
// デッキ設定
// ========================================

export const DECK = {
  SIZE: 40,
  MAX_USER_DECKS: 20,
};

// ========================================
// 属性別パック
// ========================================

export const ATTRIBUTE_PACK = {
  SHOP_PRICE: 5000,        // ショップ価格
  MERCHANT_PRICE: 4000,    // 商人価格（将来実装）
  CARDS_PER_PACK: 5,
  ATTRIBUTES: ['炎', '水', '光', '闇', '原始', '未来'],
};

// ========================================
// ロイヤルパック（闇商人専売）
// ========================================

export const ROYAL_PACK = {
  PRICE: 100000,
  CARDS_PER_PACK: 5,
  // 枠1-2: SR以上確定
  SLOT_1_2_RATES: {
    SR: 0.70,
    UR: 0.25,
    HR: 0.05,
  },
  // 枠3-4: UR以上確定
  SLOT_3_4_RATES: {
    UR: 0.80,
    HR: 0.15,
    SEC: 0.05,
  },
  // 枠5: HR以上確定
  SLOT_5_RATES: {
    HR: 0.8998,
    SEC: 0.0792,
    ALT: 0.02,
    SP: 0.0008,
    GR: 0.0002,
  },
};

// ========================================
// 投資システム定数
// ========================================

export const INVESTMENT = {
  // 手数料
  PURCHASE_FEE_RATE: 0.02,       // 購入手数料 2%
  SELL_FEE_RATE: 0.02,           // 売却手数料 2%
  MAINTENANCE_FEE_RATE: 0,       // 維持コスト廃止（手数料4%往復で短期売買ペナルティを担保）

  // 保有制限
  MAX_HOLDING_DAYS: 30,          // 最大保有期間 30日
  MIN_UNITS: 1,                  // 最小購入口数
  MAX_UNITS_PER_FUND: 100,       // 1ファンドの最大保有口数

  // 価格変動
  BASE_PRICE: 10000,             // 基準価格
  MAX_PRICE_CHANGE: 1.0,         // 最大変動率 +100%
  MIN_PRICE_CHANGE: -0.5,        // 最小変動率 -50%

  // レバレッジ（Step 4で使用）
  LEVERAGE_OPTIONS: [1, 2, 5, 10, 20, 25, 50, 100, 500, 1000],
  LEVERAGE_UNLOCK: {
    1: 0,       // 初期解放
    2: 0,       // 初期解放
    5: 0,       // 初期解放
    10: 0,      // 初期解放
    20: 0,      // 初期解放
    25: 0,      // 初期解放
    50: 5,      // 投資経験5回
    100: 10,    // 投資経験10回
    500: 15,    // 投資経験15回
    1000: 20,   // 投資経験20回 - ギャンブラー向け
  },
  LIQUIDATION_THRESHOLD: 0.5,    // ロスカット閾値 50%

  // レバレッジ別保有期限（高レバレッジほど短期決戦）
  LEVERAGE_EXPIRY: {
    1: null,    // 現物: 期限なし
    2: 30,      // 2倍: 30日
    5: 21,      // 5倍: 21日
    10: 14,     // 10倍: 14日
    20: 14,     // 20倍: 14日
    25: 7,      // 25倍以上: 7日
    50: 7,
    100: 7,
    500: 7,
    1000: 7,
  },

  // 借金（Step 6で使用）
  DEBT_INTEREST_RATE: 0.05,      // 利息 5%/戦
  DEBT_DEADLINE_DAYS: 7,         // 返済期限 7戦
  DEBT_AUTO_REPAY_RATE: 0.5,     // 対戦報酬天引き率 50%

  // 差し押さえ（Step 7で使用）
  SEIZURE_VALUE_RATE: 0.5,       // 差し押さえ充当率 50%
  PROFIT_CAP_AFTER_BANKRUPTCY: 10000, // 破産後の利益上限

  // 配当システム（長期保有ボーナス）
  DIVIDEND_RATES: {
    // 保有期間に応じた配当率（/日）
    // 1-9日: 配当なし（維持コストのみ負担）
    // 10-29日: 0.3%（維持コスト0.2%と相殺で微益）
    // 30日以上: 0.8%（安定収益）
    TIER_1: { minDays: 10, maxDays: 29, rate: 0.003 },  // 0.3%
    TIER_2: { minDays: 30, maxDays: null, rate: 0.008 }, // 0.8%
  },
};

// ファンド価格回帰圧力（基準価格への回帰）
export const FUND_REGRESSION = {
  // 閾値（基準価格からの乖離率%）、発動確率、戻り幅（%）
  THRESHOLDS: [
    { threshold: 60, chance: 0.30, amount: 6 },
    { threshold: 40, chance: 0.20, amount: 4 },
    { threshold: 20, chance: 0.10, amount: 2 },
  ],
};

// FX取引定数（Step 3で使用）
export const FX = {
  // 属性ボラティリティ
  ATTRIBUTE_VOLATILITY: {
    '光': 0.7,    // 低 - 聖域は安定
    '水': 0.8,    // やや低 - 海流は緩やか
    '炎': 1.0,    // 標準 - 火山で時々急変
    '原始': 1.1,  // やや高 - 繁殖期で変動
    '闇': 1.4,    // 高 - 魔女の呪いで予測困難
    '未来': 1.6,  // 最高 - 時空の歪みで不安定
  },

  // 手数料
  SPREAD_RATE: 0.005,            // スプレッド 0.5%
  SWAP_RATE: 0.001,              // スワップポイント 0.1%/日
};
